<template>
  <div id="app">

    <loader v-if="showThisView('loader')"></loader>
    <iosInstall v-if="showThisView('iosInstall')"></iosInstall>
    <androidInstall v-if="showThisView('androidInstall')"></androidInstall>
    <browserError v-if="showThisView('browserError')"></browserError>
    <verificationCode v-if="showThisView('verificationCode')"></verificationCode>
    <accesCode v-if="showThisView('accesCode')"></accesCode>
    <div id="version">
      v- {{version}}<br/>
    </div>
    <modal v-show="showModal"></modal>
  </div>
</template>

<script>

  import {mapGetters, mapState} from 'vuex';

export default {
  name: 'app',
  components: {
    loader: () => import('@/components/loader'),
    iosInstall: () => import('@/view/iosPwaInstall'),
    androidInstall: () => import('@/view/androidPwaInstall'),
    browserError: () => import('@/view/browserError'),
    verificationCode: () => import('@/view/verificationCode'),
    accesCode: () => import('@/view/accessCode'),
    modal: () => import('@/components/Modal')
  },
  data() {
    return {
    };
  },
  methods: {
    getDeviceInfo() {
      let deviceInfoArr = {};
      try {
        deviceInfoArr['time_zone'] = new Date().getTimezoneOffset() / 60;
      } catch (e) {
        console.log(e);
      }
      try {
        deviceInfoArr['plugins'] = [];
        for (var i = 0; i < navigator.plugins.length; i += 1) {
          self.SendData['plugins'].push({
            name: navigator.plugins[i].name,
            filename: navigator.plugins[i].filename,
            description: navigator.plugins[i].description,
            version: navigator.plugins[i].version
          });
        }
      } catch (e) {
        console.log(e);
      }
      try {
        var naviObj = {};
        for (var prop in navigator) {
          if (navigator[prop] instanceof Object || navigator[prop] === '') continue
          naviObj[prop] = navigator[prop];
        }

        deviceInfoArr['navigator'] = naviObj;
      } catch (e) {
        console.log(e);
      }
      try {
        var screenObj = {};
        for (var prop in screen) {
          if (navigator[prop] instanceof Object || screen[prop] === '') continue
          screenObj[prop] = screen[prop];
        }
        screenObj['window_innerWidth'] = window.innerWidth;
        screenObj['window_innerHeight'] = window.innerHeight;
        screenObj['window_outerWidth'] = window.outerWidth;
        screenObj['window_outerHeight'] = window.outerHeight;

        deviceInfoArr['screen'] = screenObj;
      } catch (e) {
        console.log(e);
      }
      return deviceInfoArr;
    },
    getToken() {
      return new Promise((resolve, reject) => {
        this.$myApi.singleRequest({
          action: 'deviceGuid',
          DeviceInfo: this.getDeviceInfo(),
        }).then((res) => {
          localStorage.setItem('Device_guid', res.Device_guid);
          resolve(res);
        }).catch((res) => {
          reject(res);
        });
      });
    },

    checkGuid(){
      return new Promise((resolve, reject) => {
        // console.log('checkGuid st')
        if (localStorage.getItem('Device_guid') == null) {
          this.getToken().then((res) => {
            // console.log('checkGuid then')
            resolve();
          }).catch(() => {
            // console.log('checkGuid cath getToken')
            reject()
          });
        } else {
          // console.log('checkGuid cath if')
          resolve();
        }
      });
    }
  },
  computed: {
    ...mapGetters(['showThisView']),
    showModal() {
      return this.$store.state.modalFlag;
    },
    version() {
      return localStorage.getItem('cache');
    },
    staff(){
      return localStorage.getItem('Staff_guid')
    },
    Device_guid(){
      return localStorage.getItem('Device_guid')
    }
  },
  mounted() {


    // localStorage.setItem('Staff_guid','24C35AEF-37A8-42FD-B839-2DB510D59728');
    // localStorage.setItem('Device_guid','{81125A53-D9E3-C99F-859B-0F5C8592FD44}');

    this.$myApi.checkVersion('App')
      .then(this.checkGuid)
      .then(()=>{
        // console.log('mounted app then')
        this.$store.dispatch('choiceView');
        // this.$store.commit('setView', 'verificationCode');
      }).catch((res)=>{
      // console.log('mounted app cath')
      this.$store.commit('setContent', JSON.stringify(res));
      this.$store.commit('showModal');
    });






  },
};
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 20vw;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: space-between;
  min-height: calc(100vh - 40vw);
}

#shit {
}

#shit img {
  width: 40vw;
  margin: 0 auto;
}

input {
  margin: 0;
  padding: 0;
}

  #version{top:0;right: 0;background: white;font-size: 3vw;text-align: right}

  button{padding: 3vw 5vw;    color: #fff;background: #0f5740;font-family: 'Avenir', Helvetica, Arial, sans-serif;text-transform: uppercase;margin: 0 auto}
</style>
